import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const SettingsContext = createContext({ settings: null, refresh: () => {}, update: async () => {} });

const CURRENCY_MAP = {
  BRL: { locale: "pt-BR", symbol: "R$" },
  USD: { locale: "en-US", symbol: "$" },
  EUR: { locale: "de-DE", symbol: "€" },
  HTG: { locale: "fr-HT", symbol: "G" },
};

export function SettingsProvider({ children }) {
  const { user } = useAuth();
  const [settings, setSettings] = useState(null);

  const refresh = useCallback(async () => {
    if (!user) return;
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch { /* ignore */ }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const update = async (payload) => {
    const { data } = await api.put("/settings", payload);
    setSettings(data);
    return data;
  };

  const currency = settings?.currency || "BRL";
  const cfg = CURRENCY_MAP[currency] || CURRENCY_MAP.BRL;
  const formatCurrency = (n) => {
    const value = Number(n || 0);
    try {
      return new Intl.NumberFormat(cfg.locale, { style: "currency", currency }).format(value);
    } catch {
      return `${cfg.symbol} ${value.toFixed(2)}`;
    }
  };

  return (
    <SettingsContext.Provider value={{ settings, refresh, update, formatCurrency }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
